import { render, staticRenderFns } from "./UpdateEmailTemplatesModal.vue?vue&type=template&id=e9bc9c6e"
import script from "./UpdateEmailTemplatesModal.vue?vue&type=script&lang=js"
export * from "./UpdateEmailTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports